import { useEffect, useRef, useState } from 'react';
import { styled } from '@mui/material/styles';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell, { tableCellClasses } from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import { Box, Button, ButtonGroup, Card, Checkbox, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, IconButton, Input, Stack, TextField, Tooltip } from '@mui/material';
import KeyboardIcon from '@mui/icons-material/Keyboard';
import ExtensionIcon from '@mui/icons-material/Extension';
//import { Card, Stack, Tooltip } from 'react-bootstrap';
import { IOrderHeader, OrderLine } from '../../interface/IOrders_Tasks';
import { useSelector } from 'react-redux';
import { IUser } from '../../interface/IUser';
import React from 'react';
import Barcode from 'react-barcode';
import { Sheet } from '@mui/joy';
import { AxiosInstance } from '../../api/apiInstance';
import AssemblyDialog from '../productItems/AssemblyDialog';
import ProductsItemHierarchyDialog from '../productItems/ProductsItemHierarchyDialog';
import ringer from '../Sound/beep-6-96243.mp3';

import PlaceIcon from '@mui/icons-material/Place';
import { IproductHierarchy, IproductLocation } from '../../interface/IProducts';

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: theme.palette.common.black,
    color: theme.palette.common.white,
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
  },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  '&:nth-of-type(odd)': {
    backgroundColor: theme.palette.action.hover,
  },
  // hide last border
  '&:last-child td, &:last-child th': {
    border: 0,
  },
}));
type Props = {
  //orderName : string | undefined, orderBoxes: any)
  autoSaveSingleOrderData: (status: number, refreshRequired: boolean) => void;
  setSingleOrderData: (SingleOrderData: IOrderHeader) => void;
  singleOrderData: IOrderHeader;
  allowEdit: boolean
}
interface JumpRow {
  id: number;
  name: string;
}

export default function CustomizedTables(props: Props) {
  const conditions = ["QC", "Administrator", "Packer", "Shipper"];
  const userinfo: IUser = useSelector((state: any) => state.user)
  const [barcode, setBarcode] = useState('');
  const [disabledRows, setDisabledRows] = useState([2]);
  const [open, setOpen] = useState(false);
  const [scanReadOnly, setScanReadOnly] = useState(false);
  const [dialogText, setDialogText] = useState('');
  const tmpCellDisable = [] as boolean[]
  const ShowKeyBoard = () => {
    setScanReadOnly(!scanReadOnly);
  }
  const [dialogTitle, setDialogTitle] = useState('Part Hierarchy');
  const [partDialogDataLocation, setPartDialogDataLocation] = useState<IproductLocation[]>([]);
  const [partDialogDataHierarchy, setPartDialogDataHierarchy] = useState<IproductHierarchy[]>([]);
  const [openLocatioDialog, setOpenLocatioDialog] = useState(false);
  const handleClose = () => {
    setOpen(false);
  }
  const audio = new Audio(ringer);
  const [remarks, setRemarks] = React.useState('');
  const [cylinder, setCylinder] = React.useState('Not-Needed');
  const [assemblyQty, setAssemblyQty] = React.useState('0');
  const [rowIdDialogAssembly, setRowIdDialogAssembly] = React.useState('');
  const [openDialogAssembly, setOpenDialogAssembly] = useState(false);  
  const autoSave = useRef(0);
  const GetPartHierarchyData = async (id: string) => {
    setDialogTitle('Part Hierarchy');
    setPartDialogDataHierarchy([]);
    const partName = props.singleOrderData.orderLines?.find((l => {
      if (l.id === id) return true; return false;
    }))

    try {
      await AxiosInstance({
        // url of the api endpoint (can be changed)
        url: "priorityProducts/findChildByParentPart/" + partName?.PARTNAME,
        method: "GET",
      }).then((res) => {
        const data = res.data as IproductHierarchy[];
        setPartDialogDataHierarchy(data);

      });
    } catch (e) {

    }
  }
  const GetPartLocationData = async (id: string) => {
    setDialogTitle('Part Location');
    setPartDialogDataLocation([]);
    const partName = props.singleOrderData.orderLines?.find((l => {
      if (l.id === id) return true; return false;
    }))
    try {
      await AxiosInstance({
        // url of the api endpoint (can be changed)
        url: "priority-products-locations/findAllByProductName/" + partName?.PARTNAME,
        method: "GET",
      }).then((res) => {
        const data = res.data as IproductLocation[];
        setPartDialogDataLocation(data);

      });
    } catch (e) {

    }
  }
  const handleCloseDialogAssembly = () => {
    setOpenDialogAssembly(false);
  }


  const handleCloseProductsLocationDialog = () => {
    setOpenLocatioDialog(false);
  };
  const rowsRef = useRef<(HTMLTableRowElement | null)[]>([]); // Array of refs for each row
  const rows: JumpRow[] = Array.from({ length: 30 }, (_, i) => ({
    id: i + 1,
    name: (i + 1).toString(),
  }));
  const scrollToRow = (index: number) => {
    const targetRow = rowsRef.current[index];
    if (targetRow) {
      targetRow.scrollIntoView({
        behavior: "smooth",
        block: "center",
      });
    }
  };



  const sleep = (ms: number) =>
    new Promise((resolve) => setTimeout(resolve, ms));


  function onKeyPressBarcode(event: any) {
    console.log('onKeyPressBarcode')
    //if (open) return;
    if (event.keyCode === 13) {
      event.preventDefault();
      _handleScan(event)
    }
  }

  async function _handleScanChange(e: any) {   
    //if (open) return;
    setBarcode(e.target.value);
  }

  async function _handleScan(e: any) {
    console.log('_handleScan')
    const orderLines = props.singleOrderData?.orderLines.filter((ol) => {
      if (ol.BARCODE === e.target.value) return true; return false;
    })
    if (orderLines.length > 0) {
      autoSave.current = autoSave.current  + 1;
      console.log('props.autoSaveSingleOrderData(2)', autoSave.current)
      if (autoSave.current > 10 )
      {
        console.log('props.autoSaveSingleOrderData(2) !!!!!!!!!!!!!')
        props.autoSaveSingleOrderData(2 , false);
        autoSave.current = 0;
      }
      let orderLine = orderLines.find((ol) => {
        if (ol.Fullfilled < ol.TBALANCE) return true; return false;
      });
      if (userinfo.userRoleName === 'QC') {
        orderLine = orderLines.find((ol) => {
          if (ol.FullfilledSuperViser < ol.TBALANCE) return true; return false;
        });
      }

      if (orderLine !== undefined) {
        orderLine.qtyFieldDisabled = true
        if (userinfo.userRoleName === 'QC')
          if (orderLine.FullfilledSuperViser)
            orderLine.FullfilledSuperViser = orderLine.FullfilledSuperViser + 1;
          else
            orderLine.FullfilledSuperViser = 1;
        else {
          if (orderLine.Fullfilled)
            orderLine.Fullfilled = orderLine.Fullfilled + 1;
          else
            orderLine.Fullfilled = 1;

        }
        const tmpOrderLines = props.singleOrderData.orderLines.map((item) => (item.id === e.target.id ? { ...item, ...orderLine } : item));
        props.singleOrderData.orderLines = tmpOrderLines
        const ttt = { ...props.singleOrderData }
        ttt.orderLines = tmpOrderLines
        props.setSingleOrderData(ttt)
        //await sleep(10);
        const orderLineIndex = props.singleOrderData?.orderLines.findIndex((ol) => { if (ol.id === orderLine.id) return true; return false; })
        scrollToRow(orderLineIndex)
      }
      else {
        //alert('Quantity allready fulfilled !');
        setDialogText('You have scanned more items than the order requires. Please double-check the quantity. barcode: ' + e.target.value);
        setBarcode('');
        setOpen(true);
        audio.loop = false;
        audio.play();
        return;
      }


    }
    else {
      setDialogText('You have scanned the wrong barcode. Please double-check the item.');
      setOpen(true);
      setBarcode('');
      audio.loop = false;
      audio.play();
      return;
    }
    setBarcode('');
  }

  function _handleApprovedChange(e: any) {

    const orderLine = props.singleOrderData.orderLines.find((ln) => { if (ln.id === e.target.id) return true; else return false; })
    if (orderLine !== undefined) {
      orderLine.approved = !orderLine.approved;
      const tmpOrderLines = props.singleOrderData.orderLines.map((item) => (item.id === e.target.id ? { ...item, ...orderLine } : item));
      props.singleOrderData.orderLines = tmpOrderLines
      const ttt = { ...props.singleOrderData }
      ttt.orderLines = tmpOrderLines
      props.setSingleOrderData(ttt)

    }


  }



  function _handleSetPick(e: any) {

    console.log(e.target.id, e.target.checked)
    const orderLine = props.singleOrderData.orderLines.find((ln) => { if (ln.id === e.target.id) return true; else return false; })
    if (orderLine !== undefined) {
      orderLine.picked = e.target.checked;
      const tmpOrderLines = props.singleOrderData.orderLines.map((item) => (item.id === e.target.id ? { ...item, ...orderLine } : item));
      props.singleOrderData.orderLines = tmpOrderLines
      const ttt = { ...props.singleOrderData }
      ttt.orderLines = tmpOrderLines
      props.setSingleOrderData(ttt)
    }
  }




  async function _handleSetPickingAid(e: any) {

    console.log(e.target.id, e.target.checked)
    const orderLine = props.singleOrderData.orderLines.find((ln) => { if (ln.id === e.target.id) return true; else return false; })
    if (orderLine !== undefined) {
      orderLine.pickingAid = e.target.checked;
      const tmpOrderLines = props.singleOrderData.orderLines.map((item) => (item.id === e.target.id ? { ...item, ...orderLine } : item));
      props.singleOrderData.orderLines = tmpOrderLines
      const ttt = { ...props.singleOrderData }
      ttt.orderLines = tmpOrderLines
      props.setSingleOrderData(ttt)
      const tmpOrder = {
        pickingAid: e.target.checked,

      }
      await AxiosInstance.patch('order-lines/updatePickingAid/' + e.target.id, tmpOrder)
        .then(function (response) {

        })
        .catch(function (error) {
          console.log(error);
        });
    }
  }



  async function _handleSetAssemblyAid(e: any) {
    setRowIdDialogAssembly(e.target.id)
    setAssemblyQty(props.singleOrderData.orderLines.find((item) => {
      if (item.id === e.target.id) return true; return false;
    })?.TBALANCE.toString() || '0');
    setOpenDialogAssembly(true);
  }


  async function _handleSaveSetAssemblyAid(lineId: string) {
    const orderLine = props.singleOrderData.orderLines.find((ln) => { if (ln.id === lineId) return true; else return false; })
    if (orderLine !== undefined) {
      orderLine.assemblyAid = true; //e.target.checked;       
      const tmpOrderLines = props.singleOrderData.orderLines.map((item) => (item.id === lineId ? { ...item, ...orderLine } : item));
      props.singleOrderData.orderLines = tmpOrderLines
      const ttt = { ...props.singleOrderData }
      ttt.orderLines = tmpOrderLines
      props.setSingleOrderData(ttt)
      const tmpOrder = {
        assemblyAid: orderLine.assemblyAid,
        taskInfo: remarks,
        cylinder: cylinder,
        assemblyQty: assemblyQty,


      }
      await AxiosInstance.patch('order-lines/updateAssemblyAid/' + lineId, tmpOrder)
        .then(function (response) {

        })
        .catch(function (error) {
          console.log(error);
        });
    }
  }


  function _handlePickingErrorChange(e: any) {

    const orderLine = props.singleOrderData.orderLines.find((ln) => { if (ln.id === e.target.id) return true; else return false; })
    if (orderLine !== undefined) {
      orderLine.pickingError = !orderLine.pickingError;
      const tmpOrderLines = props.singleOrderData.orderLines.map((item) => (item.id === e.target.id ? { ...item, ...orderLine } : item));
      props.singleOrderData.orderLines = tmpOrderLines
      const ttt = { ...props.singleOrderData }
      ttt.orderLines = tmpOrderLines
      props.setSingleOrderData(ttt)
    }


  }
  function _handleTextFieldChange(e: any) {

    const orderLine = props.singleOrderData.orderLines.find((ln) => { if (ln.id === e.target.id) return true; else return false; })
    if (orderLine !== undefined) {
      orderLine.lineRemarks = e.target.value;
      const tmpOrderLines = props.singleOrderData.orderLines.map((item) => (item.id === e.target.id ? { ...item, ...orderLine } : item));
      props.singleOrderData.orderLines = tmpOrderLines
      const ttt = { ...props.singleOrderData }
      ttt.orderLines = tmpOrderLines
      props.setSingleOrderData(ttt)

    }

  }
  function _handleFullfiledFieldChange(e: any) {

    if (e.target.value < 0) return;
    const val: number = parseInt(e.target.value, 0);
    const orderLine = props.singleOrderData.orderLines.find((ln) => { if (ln.id === e.target.id) return true; else return false; })
    if (orderLine !== undefined) {
      orderLine.Fullfilled = val;
      const tmpOrderLines = props.singleOrderData.orderLines.map((item) => (item.id === e.target.id ? { ...item, ...orderLine } : item));
      props.singleOrderData.orderLines = tmpOrderLines
      const ttt = { ...props.singleOrderData }
      ttt.orderLines = tmpOrderLines
      props.setSingleOrderData(ttt)
      //const orderLineInd = props.singleOrderData.orderLines.findIndex((ln) => { if (ln.id === e.target.id) return true; else return false; })
      // if (orderLine.TBALANCE.toString() !== e.target.value) {
      //   cellError[orderLineInd] = true;
      // }
      // else cellError[orderLineInd] = false;

    }

  }
  function _handleFullfiledSupervisorChange(e: any) {

    if (e.target.value < 0) return;
    const val: number = parseInt(e.target.value, 0);
    const orderLine = props.singleOrderData.orderLines.find((ln) => { if (ln.id === e.target.id) return true; else return false; })
    if (orderLine !== undefined) {
      orderLine.FullfilledSuperViser = val;
      const tmpOrderLines = props.singleOrderData.orderLines.map((item) => (item.id === e.target.id ? { ...item, ...orderLine } : item));
      props.singleOrderData.orderLines = tmpOrderLines
      const ttt = { ...props.singleOrderData }
      ttt.orderLines = tmpOrderLines
      props.setSingleOrderData(ttt)

    }

  }

  return (<>
    <AssemblyDialog

      open={openDialogAssembly}
      onClose={handleCloseDialogAssembly}
      cylinder={cylinder}
      remarks={remarks}
      lineid={rowIdDialogAssembly}
      setRemarks={setRemarks}
      setCylinder={setCylinder}
      assemblyQty={assemblyQty}
      setAssemblyQty={setAssemblyQty}
      _handleSaveSetAssemblyAid={_handleSaveSetAssemblyAid}
    />

    <ProductsItemHierarchyDialog
      
      selectedValueLocation={partDialogDataLocation}
      selectedValueHierarchy={partDialogDataHierarchy}
      open={openLocatioDialog}
      onClose={handleCloseProductsLocationDialog}
      dialogTitle={dialogTitle}
    />
    <Dialog

      open={open}
      //onClose={handleClose}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      PaperProps={{
        style: {
          backgroundColor: "#fff",
        },
      }}      >

      <DialogTitle id="alert-dialog-title" >
        {"Order"}
      </DialogTitle>
      <DialogContent>
        <DialogContentText id="alert-dialog-description" sx={{ color: "red" }} >
          {dialogText}

        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose} autoFocus={false}>
          Ok
        </Button>
      </DialogActions>
    </Dialog>

    <Card >
      <Stack direction={'row'}
        spacing={2}
        padding={2}
        sx={{
          justifyContent: 'center',
          alignItems: "center",
        }}
      >
        {/* npm i use-scan-detection */}
        <h3>Scan </h3>
        <TextField
          style={{ paddingLeft: '1rem' }}
          autoComplete='off'
          id="outlined-basic"
          variant="outlined" value={barcode}
          //ref={inputScanRef}
          autoFocus={props.allowEdit}
          // inputProps={{ readOnly: scanReadOnly }}
          onChange={_handleScanChange}
          onKeyUp={onKeyPressBarcode}
        />
        {/*  <IconButton size="large" style={{color: !scanReadOnly ? 'black' : 'gray' }} onClick={() => ShowKeyBoard()}>
           <KeyboardIcon />
          </IconButton>
          */}
      </Stack>
    </Card>
    <TableContainer component={Paper} style={{ overflowY: "auto" }}>
      <Sheet >
        {/* sx={{ maxHeight: 480, overflow: 'auto' }} */}
        <Table aria-label="customized table" stickyHeader >
          <TableHead>
            <TableRow style={{ height: '10px' }}>
              <StyledTableCell align="center">Action</StyledTableCell>
              {/* <StyledTableCell align="center">Pick</StyledTableCell> */}
              {userinfo.userRoleName === 'Picker' ?
                <>
                  <StyledTableCell align="center">picking Aid</StyledTableCell>
                </> : <></>
              }
              <StyledTableCell align="center">SKU</StyledTableCell>
              <StyledTableCell align="center">BARCODE</StyledTableCell>
              <StyledTableCell align="center">Order QTY</StyledTableCell>
              <StyledTableCell align="center">Picked QTY</StyledTableCell>
              <StyledTableCell align="center">SKU Description</StyledTableCell>
              {userinfo.userRoleName === 'Picker' ?
                <>
                  <StyledTableCell align="center">assembly Aid</StyledTableCell>
                </> : <></>
              }
              {/* <StyledTableCell align="center">priority Remarks</StyledTableCell> */}

              {conditions.some(el => userinfo.userRoleName.includes(el)) ?
                <>
                  <StyledTableCell align="center">SuperVisor Count</StyledTableCell>
                  <StyledTableCell align="center">Approved</StyledTableCell>
                  <StyledTableCell align="center">Picking Error</StyledTableCell>
                </> : <></>}
              <StyledTableCell align="center">Remarks</StyledTableCell>

            </TableRow>
          </TableHead>
          <TableBody sx={{ fontSize: '10px important' }}>
            {props.singleOrderData && props.singleOrderData?.orderLines
              && props.singleOrderData.orderLines?.length > 0 && props.singleOrderData.orderLines?.map(
                (row: OrderLine, index) => (
                  <StyledTableRow
                    key={row.id}
                    ref={(el) => (rowsRef.current[index] = el)}
                  // Assign ref to each row
                  >
                    {/* <StyledTableCell align='center' style={{ fontWeight: 'bold' }}>
                        <Checkbox
                          id={row.id}                         
                          onClick={_handleSetPick}
                          checked={row.picked}
                        />
                      </StyledTableCell> */}
                    <StyledTableCell width={150} align="center">
                      <Stack direction={'row'}>
                        <Tooltip title="Location">
                          <IconButton color="success"
                            id={row.id}
                            onClick={(event) => {
                              event.stopPropagation();
                              GetPartLocationData(row.id);
                              setOpenLocatioDialog(true);
                            }}>
                            <PlaceIcon style={{ color: 'blue' }} />
                          </IconButton>
                        </Tooltip>
                        <Tooltip title="Hierarchy">
                          <IconButton color="success"
                            id={row.id}
                            onClick={(event) => {
                              event.stopPropagation();
                              GetPartHierarchyData(row.id);
                              setOpenLocatioDialog(true);
                            }}>
                            <ExtensionIcon style={{ color: '#7CB9E8' }} />
                          </IconButton>
                        </Tooltip>
                      </Stack>
                    </StyledTableCell>
                    {userinfo.userRoleName === 'Picker' ? <>
                      <StyledTableCell width={150} align="center">
                        <Checkbox
                          id={row.id}
                          disabled={row.pickingAid}
                          onClick={_handleSetPickingAid}
                          checked={row.pickingAid}
                        />
                      </StyledTableCell>
                    </> : <></>
                    }
                    <StyledTableCell align='center' style={{ fontWeight: 'bold' }}>
                      {row.PARTNAME}
                    </StyledTableCell>
                    <StyledTableCell align="center" style={{ fontWeight: 'bold', fontSize: '10px' }}>
                      <Barcode width={1.6} height={30} value={row.BARCODE} fontSize={14} />
                    </StyledTableCell>
                    <StyledTableCell align="center" style={{ fontWeight: 'bold' }}>
                      [{row.TBALANCE}]
                    </StyledTableCell>
                    <StyledTableCell align="center"  >
                      <TextField
                        disabled={userinfo.userRoleName === 'Picker' && row.qtyFieldDisabled ? false : true}
                        id={row.id}
                        style={{ width: 80 }}
                        //label="Error"
                        variant="outlined"
                        type="number"
                        value={row.Fullfilled}
                        onChange={_handleFullfiledFieldChange}
                      />
                    </StyledTableCell>
                    <StyledTableCell width={200} align="center">{row.PARTDES}</StyledTableCell>
                    {userinfo.userRoleName === 'Picker' ? <>
                      <StyledTableCell width={150} align="center">
                        <Checkbox
                          id={row.id}
                          onClick={_handleSetAssemblyAid}
                          disabled={row.assemblyAid}
                          checked={row.assemblyAid}
                        />
                      </StyledTableCell>
                    </> : <></>
                    }
                    {/* <StyledTableCell align="center" style={{ fontWeight: 'bold' }}>
                      {row.priorityremarks}
                    </StyledTableCell> */}
                    {conditions.some(el => userinfo.userRoleName.includes(el)) ?
                      <><StyledTableCell align="center">
                        <TextField                            // disabled={userinfo.userRoleName === 'QC' || userinfo.userRoleName === 'Administrator' ? false : true}
                          disabled={userinfo.userRoleName === 'QC' && row.qtyFieldDisabled ? false : true}
                          //error={cellError[index]}
                          id={row.id}
                          style={{ width: 80 }}
                          //label="Error"
                          variant="outlined"
                          type="number"
                          value={row.FullfilledSuperViser}
                          onChange={_handleFullfiledSupervisorChange} />
                      </StyledTableCell><StyledTableCell align="center"><Checkbox
                        disabled={userinfo.userRoleName === 'QC' || userinfo.userRoleName === 'Administrator' ? false : true}
                        id={row.id}
                        checked={row.approved} onClick={_handleApprovedChange} />
                        </StyledTableCell><StyledTableCell align="center"><Checkbox
                          disabled={userinfo.userRoleName === 'QC' || userinfo.userRoleName === 'Administrator' ? false : true}
                          id={row.id}
                          checked={row.pickingError} onClick={_handlePickingErrorChange} />
                        </StyledTableCell></>

                      : <></>}

                    <StyledTableCell align="center">
                      <TextField
                        id={row.id}
                        style={{ width: 150 }}
                        name="lineRemarks"
                        value={row.lineRemarks}

                        onChange={_handleTextFieldChange}
                      />
                    </StyledTableCell>
                  </StyledTableRow>
                ))}
          </TableBody>
        </Table>
      </Sheet>
    </TableContainer>
  </>
  );
}